import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/students/$studentId')({
  staticData: { minTier: 'FRONT_END_SUPPORT' },
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/admin/people/$userId/',
      params: { userId: params.studentId },
    });
  },
});
